import React, { useState } from "react";
import "./chart.css";
import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { MdArrowDropDown } from "react-icons/md";
import DateRangePicker, {
  DateInputWithLabel,
} from "./TransmitDashboard/DateRangePicker";

import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import DualAxisChart from "./DualAxisChart";
import HorizontalBarChart from "./HorizontalBarChart";
import AdvertDashboardLayout from "./pages/ResponsiveAdvertiserDashboard/ResponsiveAdvertiserDashboardLayout/AdvertDashboardLayout";
import TotalSpendIcon from "./components/icons/TotalSpendIcon";
import ImpressionIcon from "./components/icons/ImpressionIcon";
import RadioIcon from "./components/icons/RadioIcon";
import ClicksIcon from "./components/icons/ClicksIcon";
import SignalIcon from "./components/icons/SignalIcon";
import ChannelIcon from "./components/icons/ChannelIcon";
import FilterMenuIcon from "./components/icons/FilterMenuIcon";
import DashboardDrawer from "./DashboardDrawer";
import DateRangePickerWithLabe from "./TransmitDashboard/DateRangePickerWithLabel";

const ChartJSExample = () => {
  const [tab, setTab] = useState(1);
  const [selectedItem, setSelectedItem] = useState("Advert Type");
  //   const [setStartDate, setDate] = useState(null);

  const [campaign, setCampaign] = useState("All Campaign");
  const [startDate, setStartDate] = useState("2024-04-25");
  const [endDate, setEndDate] = useState("2024-06-11");
  const [openDrawer, setOpenDrawer] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure(); // Manage drawer state
  const [adTypeFilter, setAdTypeFilter] = useState("");

  // Function to format the date
  const formatDate = (date) => {
    if (!date) return "";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Intl.DateTimeFormat("en-US", options).format(new Date(date));
  };

  const data = [
    {
      date: "April 25, 2024",
      rows: [
        {
          station: "LagosTalk",
          selectedTime: "7:00AM - 8:00AM",
          streamTime: "7:05AM, 7:10AM",
          adPlayed: "2 of 2",
          status: "Completed",
        },
        {
          station: "LagosTalk",
          selectedTime: "8:00AM - 9:00AM",
          streamTime: "8:25AM, 8:46AM",
          adPlayed: "2 of 2",
          status: "Completed",
        },
        {
          station: "LagosTalk",
          selectedTime: "11:00AM - 12:00PM",
          streamTime: "11:05AM, 11:10AM",
          adPlayed: "2 of 4",
          status: "Ongoing",
        },
      ],
    },
    {
      date: "April 26, 2024",
      rows: [
        {
          station: "LagosTalk",
          selectedTime: "7:00AM - 8:00AM",
          streamTime: "7:05AM, 7:10AM",
          adPlayed: "2 of 2",
          status: "Completed",
        },
        {
          station: "LagosTalk",
          selectedTime: "8:00AM - 9:00AM",
          streamTime: "8:25AM, 8:46AM",
          adPlayed: "2 of 2",
          status: "Completed",
        },
      ],
    },
  ];

  const digitalData = [
    {
      campaignType: "Push Notifications",
      rows: [
        {
          inventory: "Suss Ads",
          spend: "45,000",
          impression: "525,000",
          clicks: "3,400",
          clickThroughRate: "1.8%",
          costPerClick: "₦0.075",
        },
        {
          inventory: "Suss Ads",
          spend: "58,000",
          impression: "525,000",
          clicks: "3,000",
          clickThroughRate: "1.4%",
          costPerClick: "₦0.075",
        },
      ],
    },
    {
      campaignType: "Pop Ads",
      rows: [
        {
          inventory: "Suss Ads",
          spend: "45,000",
          impression: "525,000",
          clicks: "3,400",
          clickThroughRate: "1.8%",
          costPerClick: "₦0.075",
        },
        {
          inventory: "Suss Ads",
          spend: "58,000",
          impression: "525,000",
          clicks: "3,000",
          clickThroughRate: "1.4%",
          costPerClick: "₦0.075",
        },
      ],
    },
    {
      campaignType: "Digital Ads",
      rows: [
        {
          inventory: "Suss Ads",
          spend: "45,000",
          impression: "525,000",
          clicks: "3,400",
          clickThroughRate: "1.8%",
          costPerClick: "₦0.075",
        },
        {
          inventory: "Suss Ads",
          spend: "58,000",
          impression: "525,000",
          clicks: "3,000",
          clickThroughRate: "1.4%",
          costPerClick: "₦0.075",
        },
      ],
    },
    {
      campaignType: "Audio Ads",
      rows: [
        {
          inventory: "Suss Ads",
          spend: "45,000",
          impression: "525,000",
          clicks: "3,400",
          clickThroughRate: "1.8%",
          costPerClick: "₦0.075",
        },
        {
          inventory: "Suss Ads",
          spend: "58,000",
          impression: "525,000",
          clicks: "3,000",
          clickThroughRate: "1.4%",
          costPerClick: "₦0.075",
        },
      ],
    },
  ];

  const getStatusClass = (status) => {
    switch (status) {
      case "Completed":
        return "Completed";
      case "Ongoing":
        return "Ongoing";
      default:
        return "";
    }
  };

  const options = {
    title: {
      text: "Listener's Reach on LagTalk FM",
      top: "-50px",
      left: "left",
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        const point = params[0];
        return `
          <div style="text-align: left;">
            <strong>Reach:</strong> ${point.value[1].toLocaleString()}<br />
            <strong>${point.value[0]}</strong>
          </div>
        `;
      },
      backgroundColor: "#F95C39",
      borderRadius: 6,
      padding: 10,
      textStyle: {
        color: "#fff",
      },
    },
    grid: {
      left: "0%", // Set grid to start from the very left
      right: "0%", // Set grid to end at the very right
      top: "10%", // Adjust top margin for the title
      bottom: "5%", // Adjust bottom margin for better spacing
      containLabel: true, // Ensure axis labels fit within the container
    },
    xAxis: {
      type: "category",
      data: [
        "Apr 25",
        "Apr 26",
        "Apr 27",
        "Apr 28",
        "Apr 29",
        "Apr 30",
        "May 01",
        "May 02",
        "May 03",
        "May 04",
        "May 05",
        "May 06",
        "May 07",
        "May 08",
        "May 09",
        "May 10",
        "May 11",
        "Jun 01",
        "Jun 02",
        "Jun 03",
        "Jun 04",
        "Jun 05",
        "Jun 06",
        "Jun 07",
        "Jun 08",
        "Jun 09",
        "Jun 10",
        "Jun 11",
      ],
      axisLine: {
        lineStyle: {
          color: "#BEBEBE",
          width: 1,
          backgroundColor: "#000",
        },
      },
      axisTick: {
        alignWithLabel: false,
      },
    },
    yAxis: {
      type: "value",
      max: 1000000,
      axisLine: {
        lineStyle: {
          color: "#BEBEBE",
          width: 1,
        },
      },
      splitLine: {
        lineStyle: {
          color: "#EFEFEF",
          type: "dashed",
        },
      },
    },
    series: [
      {
        name: "Reach",
        type: "line",
        data: [
          ["Apr 25", 100000],
          ["Apr 26", 200000],
          ["Apr 27", 648450],
          ["Apr 28", 300000],
          ["Apr 29", 400000],
          ["Apr 30", 450000],
          ["May 01", 500000],
          ["May 02", 300000],
          ["May 03", 600000],
          ["May 04", 200000],
          ["May 05", 700000],
          ["May 06", 400000],
          ["May 07", 650000],
          ["May 08", 500000],
          ["May 09", 700000],
          ["May 10", 350000],
          ["May 11", 800000],
          ["Jun 01", 500000],
          ["Jun 02", 600000],
          ["Jun 03", 800000],
          ["Jun 04", 200000],
          ["Jun 05", 300000],
          ["Jun 06", 400000],
          ["Jun 07", 600000],
          ["Jun 08", 500000],
          ["Jun 09", 400000],
          ["Jun 10", 450000],
          ["Jun 11", 500000],
        ],
        smooth: false, // Zig-zag style
        itemStyle: {
          color: "#F95C39",
        },
        lineStyle: {
          width: 3,
          color: "#F95C39",
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(241, 97, 63, 0.15)" }, // Top color
            { offset: 1, color: "rgba(255, 255, 255, 0.15)" }, // Bottom color
          ]),
        },
      },
    ],
  };

  const CompleteCheckIcon = () => (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_708)">
        <path
          d="M12.7999 24.5C6.17233 24.5 0.799927 19.1276 0.799927 12.5C0.799927 5.8724 6.17233 0.5 12.7999 0.5C19.4275 0.5 24.7999 5.8724 24.7999 12.5C24.7999 19.1276 19.4275 24.5 12.7999 24.5ZM11.6035 17.3L20.0875 8.8148L18.3919 7.118L11.6035 13.9064L8.20873 10.5116L6.51193 12.2084L11.6035 17.3Z"
          fill="#117748"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_708">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.799927 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  const OnGoingIcon = () => (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.7999 12.5C24.7999 13.6094 24.6593 14.6719 24.3781 15.6875C24.0968 16.7031 23.6945 17.6602 23.171 18.5586C22.6476 19.457 22.0226 20.2656 21.296 20.9844C20.5695 21.7031 19.757 22.3281 18.8585 22.8594C17.9601 23.3906 17.0031 23.793 15.9874 24.0664C14.9718 24.3398 13.9093 24.4844 12.7999 24.5C11.6906 24.5 10.6281 24.3594 9.61243 24.0781C8.5968 23.7969 7.63977 23.3945 6.74133 22.8711C5.8429 22.3477 5.0343 21.7227 4.31555 20.9961C3.5968 20.2695 2.9718 19.457 2.44055 18.5586C1.9093 17.6602 1.50696 16.7031 1.23352 15.6875C0.960083 14.6719 0.815552 13.6094 0.799927 12.5C0.799927 11.3984 0.940552 10.3359 1.2218 9.3125C1.50305 8.28906 1.9054 7.33203 2.42883 6.44141C2.95227 5.55078 3.57727 4.74219 4.30383 4.01562C5.0304 3.28906 5.8429 2.66406 6.74133 2.14062C7.63977 1.61719 8.5968 1.21484 9.61243 0.933594C10.6281 0.652344 11.6906 0.507812 12.7999 0.5C13.9015 0.5 14.964 0.640625 15.9874 0.921875C17.0109 1.20312 17.9679 1.60547 18.8585 2.12891C19.7491 2.65234 20.5577 3.27734 21.2843 4.00391C22.0109 4.73047 22.6359 5.54297 23.1593 6.44141C23.6827 7.33984 24.0851 8.29688 24.3663 9.3125C24.6476 10.3281 24.7921 11.3906 24.7999 12.5ZM12.7999 23C13.7609 23 14.6866 22.875 15.5773 22.625C16.4679 22.375 17.3038 22.0234 18.0851 21.5703C18.8663 21.1172 19.5773 20.5664 20.2179 19.918C20.8585 19.2695 21.4054 18.5625 21.8585 17.7969C22.3116 17.0312 22.6671 16.1953 22.9249 15.2891C23.1827 14.3828 23.3077 13.4531 23.2999 12.5C23.2999 11.5391 23.1749 10.6133 22.9249 9.72266C22.6749 8.83203 22.3234 7.99609 21.8702 7.21484C21.4171 6.43359 20.8663 5.72266 20.2179 5.08203C19.5695 4.44141 18.8624 3.89453 18.0968 3.44141C17.3312 2.98828 16.4952 2.63281 15.589 2.375C14.6827 2.11719 13.7531 1.99219 12.7999 2C11.8312 2 10.9015 2.125 10.0109 2.375C9.12024 2.625 8.28821 2.97656 7.51477 3.42969C6.74133 3.88281 6.0304 4.43359 5.38196 5.08203C4.73352 5.73047 4.18665 6.4375 3.74133 7.20312C3.29602 7.96875 2.94055 8.80469 2.67493 9.71094C2.4093 10.6172 2.2843 11.5469 2.29993 12.5C2.29993 13.4688 2.42493 14.3984 2.67493 15.2891C2.92493 16.1797 3.27649 17.0117 3.72961 17.7852C4.18274 18.5586 4.73352 19.2695 5.38196 19.918C6.0304 20.5664 6.73743 21.1133 7.50305 21.5586C8.26868 22.0039 9.10461 22.3594 10.0109 22.625C10.9171 22.8906 11.8468 23.0156 12.7999 23ZM12.7999 17C13.2296 17 13.6476 16.9414 14.0538 16.8242C14.4601 16.707 14.8429 16.5312 15.2023 16.2969C15.5616 16.0625 15.8781 15.793 16.1515 15.4883C16.4249 15.1836 16.6632 14.8281 16.8663 14.4219L18.2257 15.0781C17.9757 15.6016 17.6632 16.0742 17.2882 16.4961C16.9132 16.918 16.4874 17.2773 16.0109 17.5742C15.5343 17.8711 15.0265 18.0977 14.4874 18.2539C13.9484 18.4102 13.3859 18.4922 12.7999 18.5C11.9406 18.5 11.1202 18.3242 10.339 17.9727C9.55774 17.6211 8.87805 17.1211 8.29993 16.4727V18.5H6.79993V14H11.2999V15.5H9.44836C9.87024 15.9688 10.3741 16.3359 10.9601 16.6016C11.546 16.8672 12.1593 17 12.7999 17ZM17.2999 8.52734V6.5H18.7999V11H14.2999V9.5H16.1515C15.7296 9.03125 15.2257 8.66406 14.6398 8.39844C14.0538 8.13281 13.4406 8 12.7999 8C12.3702 8 11.9523 8.05859 11.546 8.17578C11.1398 8.29297 10.757 8.46875 10.3976 8.70312C10.0382 8.9375 9.7218 9.20703 9.44836 9.51172C9.17493 9.81641 8.93665 10.1719 8.73352 10.5781L7.37415 9.92188C7.62415 9.39844 7.93665 8.92578 8.31165 8.50391C8.68665 8.08203 9.11243 7.72266 9.58899 7.42578C10.0656 7.12891 10.5734 6.90234 11.1124 6.74609C11.6515 6.58984 12.214 6.50781 12.7999 6.5C13.6593 6.5 14.4796 6.67578 15.2609 7.02734C16.0421 7.37891 16.7218 7.87891 17.2999 8.52734Z"
        fill="#0D4D95"
      />
    </svg>
  );

  return (
    <AdvertDashboardLayout>
      <div className="chart__container">
        <div className="chart__tabs__container">
          <span
            className={`dashboard__tab ${tab === 1 && "active__tab"}`}
            onClick={() => setTab(1)}
          >
            Radio Ads
          </span>
          <span
            className={`dashboard__tab ${tab === 2 && "active__tab"}`}
            onClick={() => setTab(2)}
          >
            Digital Ads
          </span>
        </div>
        <div className="chart__body">
          <div className="chart__advert__type">
            <div className="chart__advert_title">
              {tab === 1 ? "Radio Ads Overview" : "Digital Ads Overview"}
            </div>
            <div className="chart__advert__filter">
              {tab === 1 ? (
                <div className="campaign-filter">
                  <div
                    className="filter-menu-icon-container"
                    onClick={() => {
                      onOpen();
                      setAdTypeFilter("RadioAds 1");
                    }}
                  >
                    <FilterMenuIcon />
                  </div>
                  <div className="filter-item">
                    <label htmlFor="campaign" className="filter-label">
                      Campaign Name
                    </label>
                    <select
                      id="campaign"
                      className="filter-select"
                      value={campaign}
                      onChange={(e) => setCampaign(e.target.value)}
                    >
                      <option value="All Campaign">All Campaign</option>
                      <option value="Campaign 1">Campaign 1</option>
                      <option value="Campaign 2">Campaign 2</option>
                    </select>
                  </div>
                  <div className="filter-item">
                    <label htmlFor="start-date" className="filter-label">
                      Start Date
                    </label>
                    <input
                      type="date"
                      id="start-date"
                      className="filter-input"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="filter-item">
                    <label htmlFor="end-date" className="filter-label">
                      End Date
                    </label>
                    <input
                      type="date"
                      id="end-date"
                      className="filter-input"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>
              ) : (
                <div className="campaign-filter">
                  <div
                    className="filter-menu-icon-container"
                    onClick={() => {
                      onOpen();
                      setAdTypeFilter("DigitalAds 1");
                    }}
                  >
                    <FilterMenuIcon />
                  </div>
                  <div className="filter-item">
                    <label htmlFor="campaign" className="filter-label">
                      Campaign Name
                    </label>
                    <select
                      id="campaign"
                      className="filter-select"
                      value={campaign}
                      onChange={(e) => setCampaign(e.target.value)}
                    >
                      <option value="All Campaign">All Campaign</option>
                      <option value="Campaign 1">Campaign 1</option>
                      <option value="Campaign 2">Campaign 2</option>
                    </select>
                  </div>
                  <div className="filter-item">
                    <label htmlFor="campaign" className="filter-label">
                      Channel
                    </label>
                    <select
                      id="campaign"
                      className="filter-select"
                      value={campaign}
                      //   onChange={(e) => setCampaign(e.target.value)}
                    >
                      <option value="All Campaign">All Campaign</option>
                    </select>
                  </div>
                  <div className="filter-item">
                    <label htmlFor="campaign" className="filter-label">
                      Data Source
                    </label>
                    <select
                      id="campaign"
                      className="filter-select"
                      value={campaign}
                      //   onChange={(e) => setCampaign(e.target.value)}
                    >
                      <option value="All Campaign">All Campaign</option>
                    </select>
                  </div>
                  <div className="filter-item">
                    <label htmlFor="start-date" className="filter-label">
                      Start Date
                    </label>
                    <input
                      type="date"
                      id="start-date"
                      className="filter-input"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="filter-item">
                    <label htmlFor="end-date" className="filter-label">
                      End Date
                    </label>
                    <input
                      type="date"
                      id="end-date"
                      className="filter-input"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="card-container">
        <div className="card-wrapper">
          <div className="card-top">
            <TotalSpendIcon />
            <h3 className="card-type">Total Spend</h3>
          </div>
          <div className="card-bottom">₦300,540</div>
        </div>
        <div className="card-wrapper">
          <div className="card-top">
            <ImpressionIcon />

            <h3 className="card-type">
              {tab === 1 ? "Listener’s Reach" : "Impressions"}
            </h3>
          </div>
          <div className="card-bottom">540,000</div>
        </div>
        <div className="card-wrapper">
          <div className="card-top">
            {tab === 1 ? <SignalIcon /> : <ClicksIcon />}
            <h3 className="card-type">
              {tab === 1 ? "Airtime Utilization" : "Clicks"}
            </h3>
          </div>
          <div className="card-bottom">58%</div>
        </div>
        <div className="card-wrapper">
          <div className="card-top">
            {tab === 1 ? <RadioIcon /> : <ChannelIcon />}
            <h3 className="card-type">
              {tab === 1 ? "Radio Station" : "Channels"}
            </h3>
          </div>
          <div className="card-bottom">2</div>
        </div>
      </div>
      {tab === 1 ? (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <h2 style={{ fontSize: "16px", fontWeight: "600", width: "100%" }}>
              Listener's Reach on LagTalk FM
            </h2>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
                gap: "20px",
              }}
            >
              <div
                className="filter-menu-icon-container"
                onClick={() => {
                  onOpen();
                  setAdTypeFilter("RadioAds 2");
                }}
              >
                <FilterMenuIcon />
              </div>
              <div className="filter-item">
                <label htmlFor="campaign" className="filter-label">
                  Media KPI
                </label>
                <select
                  id="campaign"
                  className="filter-select"
                  value={campaign}
                  //   onChange={(e) => setCampaign(e.target.value)}
                >
                  <option value="All Campaign">Listener Reach</option>
                </select>
              </div>
              <div className="filter-item">
                <label htmlFor="campaign" className="filter-label">
                  Radio Station
                </label>
                <select
                  id="campaign"
                  className="filter-select"
                  value={campaign}
                  //   onChange={(e) => setCampaign(e.target.value)}
                >
                  <option value="All Campaign">All</option>
                </select>
              </div>
              <div className="filter-item">
                <label htmlFor="campaign" className="filter-label">
                  Data Breakdown
                </label>
                <select
                  id="campaign"
                  className="filter-select"
                  value={campaign}
                  //   onChange={(e) => setCampaign(e.target.value)}
                >
                  <option value="All Campaign">Day</option>
                </select>
              </div>
            </div>
          </div>

          <div style={{ marginTop: "20px" }}>
            <ReactECharts
              option={options}
              style={{ height: "400px", width: "100%" }}
              opts={{ renderer: "canvas" }}
              notMerge={true}
              lazyUpdate={true}
            />
          </div>
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <h2 style={{ fontSize: "16px", fontWeight: "600", width: "100%" }}>
              Impression and Clicks
            </h2>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
                gap: "20px",
              }}
            >
              <div
                className="filter-menu-icon-container"
                onClick={() => {
                  onOpen();
                  setAdTypeFilter("DigitalAds 2");
                }}
              >
                <FilterMenuIcon />
              </div>
              <div className="filter-item">
                <label htmlFor="campaign" className="filter-label">
                  Media KPI 1
                </label>
                <select
                  id="campaign"
                  className="filter-select"
                  value={campaign}
                  //   onChange={(e) => setCampaign(e.target.value)}
                >
                  <option value="All Campaign">Impression</option>
                </select>
              </div>
              <div className="filter-item">
                <label htmlFor="campaign" className="filter-label">
                  Media KPI 2
                </label>
                <select
                  id="campaign"
                  className="filter-select"
                  value={campaign}
                  //   onChange={(e) => setCampaign(e.target.value)}
                >
                  <option value="All Campaign">Clicks</option>
                </select>
              </div>
              <div className="filter-item">
                <label htmlFor="campaign" className="filter-label">
                  Date Breakdown
                </label>
                <select
                  id="campaign"
                  className="filter-select"
                  value={campaign}
                  //   onChange={(e) => setCampaign(e.target.value)}
                >
                  <option value="All Campaign">Monthly</option>
                </select>
              </div>
            </div>
          </div>
          <div className="digital-charts-container">
            <HorizontalBarChart />
            <DualAxisChart />
          </div>
        </>
      )}
      <div className="radio-broadcast-summary">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <div className="summary-title">
            {tab === 1
              ? "Radio Broadcast Summary"
              : "Performance By Channel and Source"}
          </div>
          {tab === 1 && (
            <div className="filter-item">
              <label htmlFor="campaign" className="filter-label">
                Data Breakdown
              </label>
              <select
                id="campaign"
                className="filter-select"
                value={campaign}
                //   onChange={(e) => setCampaign(e.target.value)}
              >
                <option value="All Campaign">Day</option>
              </select>
            </div>
          )}
        </div>
        {tab === 1 ? (
          <>
            <table className="summary-table">
              <thead>
                <tr>
                  <th>
                    <div className="summary-column-title">
                      <span>Ad Date</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Radio Station</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Selected Time</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Stream Tim</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Ad Played</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Ad Status</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((group) => (
                  <>
                    {group.rows.map((row, index) => (
                      <tr
                        key={`${group.date}-${index}`}
                        className="summary-row"
                      >
                        <td>{index === 0 ? group.date : ""}</td>
                        <td>{row.station}</td>
                        <td>{row.selectedTime}</td>
                        <td>{row.streamTime}</td>
                        <td>{row.adPlayed}</td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <span
                            // className={`status-icon ${getStatusClass(row.status)}`}
                            >
                              {getStatusClass(row.status) === "Completed" ? (
                                <CompleteCheckIcon />
                              ) : (
                                <OnGoingIcon />
                              )}
                            </span>
                            <span>
                              {getStatusClass(row.status) === "Completed"
                                ? "Completed"
                                : "Ongoing"}
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                ))}
              </tbody>
            </table>
            <div className="summary-table-mobile">
              <div className="summary-table-mobile-header">
                Ad Date : April 25, 2024
              </div>
              <div className="summary-table-mobile-body">
                <div className="advert-summary-info-wrapper">
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Radio Station
                    </span>
                    <span className="advert-summary-info-value">
                      Lagos Talk FM
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Selected Time
                    </span>
                    <span className="advert-summary-info-value">
                      7:00AM- 8:00AM
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Stream TIme</span>
                    <span className="advert-summary-info-value">
                      7:05am, 7:10am
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Ad Played </span>
                    <span className="advert-summary-info-value">2 of 2</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Ad Status </span>
                    <span className="advert-summary-info-value">
                      <CompleteCheckIcon /> <span>Completed</span>
                    </span>
                  </div>
                </div>
                <div className="advert-summary-info-wrapper">
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Radio Station
                    </span>
                    <span className="advert-summary-info-value">
                      Lagos Talk FM
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Selected Time
                    </span>
                    <span className="advert-summary-info-value">
                      7:00AM- 8:00AM
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Stream TIme</span>
                    <span className="advert-summary-info-value">
                      7:05am, 7:10am
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Ad Played </span>
                    <span className="advert-summary-info-value">2 of 2</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Ad Status </span>
                    <span className="advert-summary-info-value">
                      <CompleteCheckIcon /> <span>Completed</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="summary-table-mobile">
              <div className="summary-table-mobile-header">
                Ad Date : April 25, 2024
              </div>
              <div className="summary-table-mobile-body">
                <div className="advert-summary-info-wrapper">
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Radio Station
                    </span>
                    <span className="advert-summary-info-value">
                      Lagos Talk FM
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Selected Time
                    </span>
                    <span className="advert-summary-info-value">
                      7:00AM- 8:00AM
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Stream TIme</span>
                    <span className="advert-summary-info-value">
                      7:05am, 7:10am
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Ad Played </span>
                    <span className="advert-summary-info-value">2 of 2</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Ad Status </span>
                    <span className="advert-summary-info-value">
                      <CompleteCheckIcon /> <span>Completed</span>
                    </span>
                  </div>
                </div>
                <div className="advert-summary-info-wrapper">
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Radio Station
                    </span>
                    <span className="advert-summary-info-value">
                      Lagos Talk FM
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Selected Time
                    </span>
                    <span className="advert-summary-info-value">
                      7:00AM- 8:00AM
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Stream TIme</span>
                    <span className="advert-summary-info-value">
                      7:05am, 7:10am
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Ad Played </span>
                    <span className="advert-summary-info-value">2 of 2</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Ad Status </span>
                    <span className="advert-summary-info-value">
                      <CompleteCheckIcon /> <span>Completed</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <table className="summary-table">
              <thead>
                <tr>
                  <th>
                    <div className="summary-column-title">
                      <span>Campaign Type</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Inventory</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Spend</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Impressions</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Clicks</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Click Through Rate</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                  <th>
                    <div className="summary-column-title">
                      <span>Cost per Click</span>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.14121 9.1912C8.07047 9.25711 8.01373 9.3366 7.97438 9.42492C7.93503 9.51324 7.91387 9.60858 7.91216 9.70526C7.91045 9.80193 7.92824 9.89796 7.96445 9.98761C8.00066 10.0773 8.05456 10.1587 8.12293 10.2271C8.1913 10.2954 8.27274 10.3493 8.36239 10.3856C8.45205 10.4218 8.54808 10.4396 8.64475 10.4378C8.74142 10.4361 8.83677 10.415 8.92508 10.3756C9.0134 10.3363 9.09289 10.2795 9.15881 10.2088L12.25 7.1176L15.3412 10.2088C15.4777 10.336 15.6582 10.4052 15.8448 10.4019C16.0313 10.3986 16.2092 10.3231 16.3412 10.1912C16.4731 10.0592 16.5486 9.88127 16.5519 9.69474C16.5552 9.50821 16.486 9.32769 16.3588 9.1912L12.7588 5.5912C12.6238 5.45636 12.4408 5.38063 12.25 5.38063C12.0592 5.38063 11.8762 5.45636 11.7412 5.5912L8.14121 9.1912ZM16.3588 15.8088C16.486 15.6723 16.5552 15.4918 16.5519 15.3053C16.5486 15.1187 16.4731 14.9408 16.3412 14.8088C16.2092 14.6769 16.0313 14.6014 15.8448 14.5981C15.6582 14.5948 15.4777 14.664 15.3412 14.7912L12.25 17.8824L9.15881 14.7912C9.02232 14.664 8.8418 14.5948 8.65527 14.5981C8.46874 14.6014 8.29077 14.6769 8.15885 14.8088C8.02694 14.9408 7.95137 15.1187 7.94808 15.3053C7.94479 15.4918 8.01403 15.6723 8.14121 15.8088L11.7412 19.4088C11.8762 19.5436 12.0592 19.6194 12.25 19.6194C12.4408 19.6194 12.6238 19.5436 12.7588 19.4088L16.3588 15.8088Z"
                          fill="#3C3B39"
                        />
                      </svg>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {digitalData.map((group) => (
                  <>
                    {group.rows.map((row, index) => (
                      <tr
                        key={`${group.date}-${index}`}
                        className="summary-row"
                      >
                        <td>{index === 0 ? group.campaignType : ""}</td>
                        <td>{row.inventory}</td>
                        <td>{row.spend}</td>
                        <td>{row.impression}</td>
                        <td>{row.clicks}</td>
                        <td>{row.clickThroughRate}</td>
                        <td>{row.costPerClick}</td>
                        <td></td>
                      </tr>
                    ))}
                  </>
                ))}
              </tbody>
            </table>
            <div className="summary-table-mobile">
              <div className="summary-table-mobile-header">
                Channel : Push Notifications
              </div>
              <div className="summary-table-mobile-body">
                <div className="advert-summary-info-wrapper">
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Data Source</span>
                    <span className="advert-summary-info-value">
                      Facebook ads
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Spend</span>
                    <span className="advert-summary-info-value">N45,000</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Impressions</span>
                    <span className="advert-summary-info-value">254,523</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Clicks</span>
                    <span className="advert-summary-info-value">3,400</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Click through rate{" "}
                    </span>
                    <span className="advert-summary-info-value">1.8%</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Cost Per Click{" "}
                    </span>
                    <span className="advert-summary-info-value">N0.075</span>
                  </div>
                </div>
                <div className="advert-summary-info-wrapper">
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Data Source</span>
                    <span className="advert-summary-info-value">
                      Facebook ads
                    </span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Spend</span>
                    <span className="advert-summary-info-value">N45,000</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Impressions</span>
                    <span className="advert-summary-info-value">254,523</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">Clicks</span>
                    <span className="advert-summary-info-value">3,400</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Click through rate{" "}
                    </span>
                    <span className="advert-summary-info-value">1.8%</span>
                  </div>
                  <div className="advert-summary-info">
                    <span className="advert-summary-info-key">
                      Cost Per Click{" "}
                    </span>
                    <span className="advert-summary-info-value">N0.075</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {adTypeFilter === "RadioAds 1" && (
        <DashboardDrawer isOpen={isOpen} onClose={onClose}>
          <Flex flexDirection={"column"} gap={5}>
            <Box>
              <Text mb={3} fontWeight={600}>
                Select Campaign
              </Text>
              <Select>
                <option value="Option 1">Campaign 3</option>
              </Select>
            </Box>
            <DateRangePickerWithLabe
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </Flex>
        </DashboardDrawer>
      )}
      {adTypeFilter === "RadioAds 2" && (
        <DashboardDrawer isOpen={isOpen} onClose={onClose}>
          <Flex flexDirection={"column"} gap={5}>
            <Box>
              <Text mb={3} fontWeight={600}>
                Media KPI 1
              </Text>
              <Select>
                <option value="Option 1">Listener’s Reach</option>
              </Select>
            </Box>
            <Box>
              <Text mb={3} fontWeight={600}>
                Radio Station
              </Text>
              <Select>
                <option value="Option 1">LagFM</option>
              </Select>
            </Box>
            <Box>
              <Text mb={3} fontWeight={600}>
                Date Breakdown
              </Text>
              <Select>
                <option value="Option 1">Day</option>
              </Select>
            </Box>
          </Flex>
        </DashboardDrawer>
      )}
      {adTypeFilter === "DigitalAds 1" && (
        <DashboardDrawer isOpen={isOpen} onClose={onClose}>
          <Flex flexDirection={"column"} gap={5}>
            <Box>
              <Text mb={3} fontWeight={600}>
                Select Campaign
              </Text>
              <Select>
                <option value="Option 1">Campaign 3</option>
              </Select>
            </Box>
            <Flex w={'100%'} gap={'10px'}>
              <Box w={'100%'}>
                <Text mb={3} fontWeight={600}>
                  Channel
                </Text>
                <Select>
                  <option value="Option 1">All</option>
                </Select>
              </Box>
              <Box w={'100%'}>
                <Text mb={3} fontWeight={600}>
                  Data Source
                </Text>
                <Select>
                  <option value="Option 1">All</option>
                </Select>
              </Box>
            </Flex>
            <DateRangePickerWithLabe
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </Flex>
        </DashboardDrawer>
      )}
      {adTypeFilter === "DigitalAds 2" && (
        <DashboardDrawer isOpen={isOpen} onClose={onClose}>
          <Flex flexDirection={"column"} gap={5}>
            <Box>
              <Text mb={3} fontWeight={600}>
                Media KPI 1
              </Text>
              <Select>
                <option value="Option 1">Impressions</option>
              </Select>
            </Box>
            <Box>
              <Text mb={3} fontWeight={600}>
              Media KPI 2
              </Text>
              <Select>
                <option value="Option 1">Click</option>
              </Select>
            </Box>
            <Box>
              <Text mb={3} fontWeight={600}>
                Date Breakdown
              </Text>
              <Select>
                <option value="Option 1">Day</option>
              </Select>
            </Box>
          </Flex>
        </DashboardDrawer>
      )}
    </AdvertDashboardLayout>
  );
};

export default ChartJSExample;
